import {Pipe, PipeTransform} from '@angular/core';
import {CurrentUser} from '../user/current-user.service';

@Pipe({
  name: 'JsDate',
  pure: true
})
export class JsDatePipe implements PipeTransform {

  constructor(private currentUser: CurrentUser) {
  }

  transform(date: Date, args?: any): string {
    if (!date) {
      return '';
    }
    return date.toLocaleDateString(
      this.currentUser.locale,
      {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }
    );
  }

}
